import { ButtonV2, SelectV2, SelectV2Option } from '@cimplico/components';
import { useState } from 'react';
import { toastNotification } from '../../../../../components/toast/Toast';
import { useAtosaTaxpayers } from '../../../../../queries/use-atosa-taxpayers';
import { useLinkAtosaTaxpayer } from '../../../../../queries/use-link-atosa-taxpayer';

type TaxpayerSelectProps = {
    entityId: string;
};
function TaxpayerSelect({ entityId }: TaxpayerSelectProps): JSX.Element {
    const [search, setSearch] = useState('');
    const taxpayerQuery = useAtosaTaxpayers();
    const linkTaxpayers = useLinkAtosaTaxpayer();

    const taxpayers = taxpayerQuery.data?.taxPayers ?? [];
    const [selected, setSelected] = useState<SelectV2Option[]>([]);

    function handleSave(): void {
        const taxpayer = selected[0];
        if (!selected[0]) {
            return;
        }
        linkTaxpayers.mutate([{ entityId, taxPayerId: taxpayer.value.toString(), name: taxpayer.label }], {
            onSuccess: () => {
                toastNotification('success', `Successfully linked taxpayer to entity!`);
            },
            onError: (res) => {
                toastNotification('error', 'Unable to link taxpayer to entity.', res.response?.data?.message);
            },
        });
    }

    return (
        <div className="lg:w-1/2">
            <SelectV2
                onSearch={setSearch}
                options={taxpayers
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .filter((tp) => tp.name.toLowerCase().includes(search.toLowerCase()))
                    .map((tp) => {
                        return {
                            label: tp.name,
                            value: tp.uuid,
                            isDisabled: Boolean(tp.entity),
                            disabledHint: `This taxpayer is already linked to: ${tp.entity?.name}`,
                            description: tp.abn,
                        };
                    })}
                title="Select a taxpayer"
                value={selected}
                isLoading={taxpayerQuery.isLoading}
                onChange={setSelected}
            />
            <div className="w-fit ml-auto mt-2">
                <ButtonV2
                    label="Save"
                    size="sm"
                    isDisabled={selected.length !== 1 || linkTaxpayers.isLoading}
                    isLoading={linkTaxpayers.isLoading}
                    onClick={handleSave}
                />
            </div>
        </div>
    );
}

export default TaxpayerSelect;
